import { useTranslation } from 'react-i18next';

import { deviceService } from '@/api/domains/device';
import type { DeviceStatusFilter, DeviceTypeFilter } from '@/api/domains/device';
import { useExport } from '@/hooks/ui/useExport';


export interface UseDeviceExportParams {
  searchText?: string;
  typeFilter?: DeviceTypeFilter;
  statusFilter?: DeviceStatusFilter;
}

interface UseDeviceExportResult {
  onExport: () => Promise<void>;
  isExporting: boolean;
}

export function useDeviceExport(params: UseDeviceExportParams): UseDeviceExportResult {
  const { t: translate } = useTranslation();

  const { onExport, isExporting } = useExport({
    exportFn: () => deviceService.export({
      searchText: params.searchText,
      typeFilter: params.typeFilter,
      statusFilter: params.statusFilter,
    }),
    successMessage: translate('device:messages.exportSuccess'),
    errorMessage: translate('device:messages.exportError'),
  });

  return { onExport, isExporting };
}

export default useDeviceExport;
